import { RouteType } from "types/RouteType";
import AddRawMaterialsWorkflowStore from "./AddRawMaterialsWorkflowStore";

const AddRawMaterialsWorkflowRoute: RouteType = {
  name: "Add Raw Materials Workflow",
  path: "/workflows/add-raw-materials",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Raw Materials",
      component: () => import("./AddRawMaterialsWorkflowHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./AddRawMaterialsWorkflow"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    // Initialize store if not exists
    if (!rootStore.addRawMaterialsWorkflowStore) {
      rootStore.addRawMaterialsWorkflowStore = new AddRawMaterialsWorkflowStore(rootStore);
    }
    // Reset to clean state when entering
    const store = rootStore.addRawMaterialsWorkflowStore as AddRawMaterialsWorkflowStore;
    store.reset();
    return true;
  },
};

export default AddRawMaterialsWorkflowRoute;
